export const getBaseUrl = () => {
  if (
    process.env.NODE_ENV === "development" &&
    typeof window !== "undefined"
  ) {
    return `${window.location.protocol}//${window.location.hostname}:8888`;
  }
  return "";
};
